export default __webpack_public_path__ + "static/media/16.bd2a407c.svg";